import { NSValidation } from './../../classes/NSValidation';
import { BaseComponent } from './../base/base.component';
import { Component, OnInit } from '@angular/core';
declare var bootbox:any;
@Component({
  selector: 'app-survey-ne',
  template: require('./survey-ne.component.html')
})
export class SurveyNeComponent extends BaseComponent implements OnInit {

  public survey = {
    title: "",
    description:"",
    instructions: "",
    managerDescription:"",
    managerInstructions: "",
    organizationId: -1,
    managerName: "fnln",
    usePrefix: 0,
    defaultEmailFolder: "CLS",
    defaultReportFunction: "CLS"
  };

  public surveyId = -1;
  public organizations = [];

  
  ngOnInit() {
    super.ngOnInit();
    this.loadOrganizations();
  }

  public loadOrganizations() {
    this.busy = this.lsApi.getOrganizations().subscribe(resp => {
        if(resp.status) {
            this.organizations = resp.data;
        }
    },
    error => {
        console.log(error);
    });
  }


  public routeParamsUpdated() {
    this.surveyId = this.default(this.currentRouteParams["surveyId"],-1);
    if(this.surveyId>0)
      this.loadSurveyById();
    else 
      this.surveyId = -1;
  }

  public loadSurveyById() {
      this.busy = this.lsApi.getSurveyById(this.surveyId).subscribe(resp => {
        if(resp.status) {
            this.survey = resp.data[0];
            console.log(this.survey);
        }
    },
    error => {
        console.log(error);
    });
  }

  public save() {
    var validate:NSValidation = new NSValidation();

    var errorMessage = "";
    if(validate.isEmpty(this.survey.title)) {
        errorMessage = "Please provide a title for this survey";
    }
    //else if(this.survey.organizationId==null || this.survey.organizationId <=0 ) {
        //errorMessage = "Please select a organization";
    //}

    if(errorMessage!="") {
        bootbox.alert(errorMessage);
    }
    else {
        this.busy = this.lsApi.saveSurvey(this.surveyId, this.survey.usePrefix, this.survey.managerName, this.survey.title, this.survey.description,
        this.survey.instructions, this.survey.managerDescription, this.survey.managerInstructions, this.survey.defaultEmailFolder, this.survey.defaultReportFunction).subscribe(resp => {
            if(resp.status) {
                this.router.navigate(['/admin/surveys']).then(() => {
                  this.appToast.success("Surveys Successfully Saved","Surveys Saved")
                })
            }
        },
        error => {
            console.log(error);
        });
    }
  }

  public cancel() {
    this.router.navigate(['/admin/surveys']);
  }

  public delete() {

    bootbox.confirm({message:"Do you want to delete '" + this.survey.title + "' survey and all it's data?<br><small>All their data will be lost. This cannot be undone.</small>",
    buttons: {
        confirm: {
            label: 'Yes',
            className: 'btn-primary'
        },
        cancel: {
            label: 'No',
            className: 'btn-primary btn-simple'
        }
    },
    callback: (result) => {
        if(result) {

          this.busy = this.lsApi.deleteSurveyById(this.surveyId).subscribe(resp => {
              if(resp.status) {
                  this.router.navigate(['/admin/surveys']).then(() => {
                    this.appToast.success("Surveys Successfully Deleted","Surveys Deleted")
                  })
              }
          },
          error => {
              console.log(error);
          });

        }
      }});
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/survey-ne/survey-ne.component.ts